export abstract class WebAgent {
  static IsMobile() {
    if (navigator) {
      return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    }
    return false;
  }
  static IsInternetExplore() {
    if (navigator) {
      return /trident|edge/i.test(navigator.userAgent);
    }
    return false;
  }
}
